// extracted by mini-css-extract-plugin
export default {"eventDetailShareCard":"EventDetails_eventDetailShareCard__xCLOj","eventDetailShare":"EventDetails_eventDetailShare__AXt-e"};